import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { useTheme } from 'next-themes';

export const useNativeStatusBar = () => {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const updateStatusBar = async () => {
      try {
        if (resolvedTheme === 'dark') {
          await StatusBar.setStyle({ style: Style.Dark });
        } else {
          await StatusBar.setStyle({ style: Style.Light });
        }
      } catch (e) {
        // Silently fail if status bar not available
      }
    };

    updateStatusBar();
  }, [resolvedTheme]);

  const setStatusBarLight = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await StatusBar.setStyle({ style: Style.Light });
      } catch (e) {
        // Silently fail
      }
    }
  };

  const setStatusBarDark = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await StatusBar.setStyle({ style: Style.Dark });
      } catch (e) {
        // Silently fail
      }
    }
  };

  const hideStatusBar = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await StatusBar.hide();
      } catch (e) {
        // Silently fail
      }
    }
  };

  const showStatusBar = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await StatusBar.show();
      } catch (e) {
        // Silently fail
      }
    }
  };

  return {
    setStatusBarLight,
    setStatusBarDark,
    hideStatusBar,
    showStatusBar,
  };
};
